export default __webpack_public_path__ + "static/media/Background_00227.6cda9a21.png";